// extracted by mini-css-extract-plugin
export default {"container":"Ivo7z6UJLSte6oMNoRbQ","backButton":"CsNErwRHps6MVhihaw14","backLabel":"YfRbzYMYF0o2B7cBKCfz"};